// September travel intelligence for each destination
// The app "just knows" what's happening — weather, events, what's in season, what to watch out for
const septemberContext = {
  'Dubrovnik + Hvar': {
    weatherVibe: 'Warm & perfect',
    temp: '75-82°F',
    water: 'Adriatic still warm (75°F) — perfect for swimming and kayaking',
    crowdLevel: 'Low',
    crowdNote: 'Cruise ships thin out after Labor Day. You\'ll have Old Town almost to yourselves.',
    inSeason: ['Figs are peak season', 'Local wine harvest starts', 'Oyster season in Ston'],
    events: ['Dubrovnik Film Festival (early Sep)'],
    bestFor: 'Beach + culture without the summer crush',
    warning: null,
  },
  'Santorini + Athens': {
    weatherVibe: 'Hot & dry',
    temp: '78-84°F',
    water: 'Aegean warm (77°F) — best swimming month',
    crowdLevel: 'Medium',
    crowdNote: 'Still busy in Oia but manageable. First 2 weeks busier than last 2.',
    inSeason: ['Grape harvest — wine festivals everywhere', 'Fresh figs and pomegranates', 'Assyrtiko wine at its best'],
    events: ['Santorini Wine Festival', 'Athens Open Air Film Festival'],
    bestFor: 'Wine harvest + caldera sunsets with fewer selfie sticks',
    warning: 'Meltemi winds can be strong — catamaran trips may cancel.',
  },
  'Amalfi Coast + Rome': {
    weatherVibe: 'Warm & golden',
    temp: '75-82°F',
    water: 'Mediterranean perfect (78°F)',
    crowdLevel: 'Medium-Low',
    crowdNote: 'Summer hordes gone. Positano walkable again. Rome doesn\'t feel like a sauna.',
    inSeason: ['Vendemmia — grape harvest across Italy', 'Lemon season finale', 'Porcini mushrooms starting', 'Fresh truffles from Umbria'],
    events: ['Venice Film Festival spills energy south', 'Regata Storica in nearby Venice'],
    bestFor: 'The sweet spot — warm enough for beaches, cool enough for Rome walks',
    warning: null,
  },
  'Lisbon + Porto': {
    weatherVibe: 'Warm & sunny',
    temp: '72-80°F',
    water: 'Atlantic refreshing (68°F) — great for surfing near Lisbon',
    crowdLevel: 'Low',
    crowdNote: 'September is Portugal\'s best-kept secret. Locals say this is the real summer. Porto is even quieter than Lisbon.',
    inSeason: ['Port wine harvest in the Douro Valley — quintas open for tastings', 'Seafood is peak quality in both cities', 'Pastéis de nata always in season', 'Francesinha season (always) in Porto'],
    events: ['Surf season kicks in at Ericeira (near Lisbon)', 'Douro Valley grape harvest — wine festivals', 'Porto wine cellars host special tastings', 'São Miguel festas (Azores connection flights from Porto)'],
    bestFor: 'Two cities, one train ride. Wine harvest in the Douro, surf in Ericeira, port wine cellars in Gaia.',
    warning: null,
  },
  'Barcelona + Ibiza': {
    weatherVibe: 'Hot & lively',
    temp: '75-82°F',
    water: 'Mediterranean warm (77°F)',
    crowdLevel: 'Medium',
    crowdNote: 'Beach clubs still going but not sardine-packed. Ibiza closing parties start.',
    inSeason: ['Ibiza closing parties (legendary)', 'La Mercè festival in Barcelona (Sep 24)', 'Cava harvest season'],
    events: ['La Mercè — Barcelona\'s biggest festival with free concerts and fire runs', 'Ibiza closing parties (DC10, Amnesia, Pacha)'],
    bestFor: 'Ibiza closing parties + La Mercè = best nightlife month on Earth',
    warning: 'La Mercè week = hotels book fast in Barcelona.',
  },
  'Nice + Monaco': {
    weatherVibe: 'Warm & glamorous',
    temp: '72-78°F',
    water: 'Mediterranean comfortable (75°F)',
    crowdLevel: 'Low-Medium',
    crowdNote: 'Riviera calms down after August. Monaco is never empty but September is manageable.',
    inSeason: ['Fig and grape harvest', 'Rosé season (always)', 'Truffle season starting in Piedmont nearby'],
    events: ['Monaco Yacht Show (late Sep) — see the mega yachts'],
    bestFor: 'Riviera glamour without fighting for a beach chair',
    warning: null,
  },
  'London + Cotswolds': {
    weatherVibe: 'Crisp & pleasant',
    temp: '58-66°F',
    water: 'Too cold for swimming',
    crowdLevel: 'Medium',
    crowdNote: 'Summer tourists gone, but theatre season is buzzing. Great energy.',
    inSeason: ['West End new season premieres', 'Blackberry picking in Cotswolds', 'Pub gardens still usable'],
    events: ['London Fashion Week (mid-Sep)', 'Totally Thames river festival', 'London Design Festival'],
    bestFor: 'Culture, theatre, and cozy Cotswolds pubs before it gets cold',
    warning: 'Pack layers. Rain possible. But that\'s London\'s charm.',
  },
  'Paris': {
    weatherVibe: 'Perfect autumn warmth',
    temp: '60-70°F',
    water: 'N/A',
    crowdLevel: 'Medium',
    crowdNote: 'La Rentrée — Parisians are back, city buzzes with energy. Tourist crowds thinner.',
    inSeason: ['Wine harvest across France', 'Mushroom season (chanterelles, cèpes)', 'Fashion week prep'],
    events: ['Paris Fashion Week (late Sep)', 'European Heritage Days — palaces open free', 'Jazz à la Villette'],
    bestFor: 'Paris at its most Parisian. Locals are back. Cafés are alive.',
    warning: null,
  },
  'Reykjavik + Golden Circle': {
    weatherVibe: 'Cool & dramatic',
    temp: '42-52°F',
    water: 'Geothermal hot springs only',
    crowdLevel: 'Low',
    crowdNote: 'Shoulder season = cheaper flights and hotels. Way fewer tourists.',
    inSeason: ['Northern Lights season STARTS in September', 'Wild blueberries', 'Sheep round-up (réttir) — incredible cultural experience'],
    events: ['Reykjavik International Film Festival', 'First Northern Lights of the season'],
    bestFor: 'Northern Lights + Golden Circle without summer prices or crowds',
    warning: 'Weather unpredictable. Days getting noticeably shorter. Bring waterproof everything.',
  },
  'Dublin + Cliffs of Moher': {
    weatherVibe: 'Mild & green',
    temp: '54-62°F',
    water: 'Cold (57°F) — wetsuits only',
    crowdLevel: 'Low',
    crowdNote: 'Tourist season winding down. Pubs are locals-only vibes.',
    inSeason: ['Oyster season begins (Galway!)', 'Irish music sessions in full swing', 'Pub season (always)'],
    events: ['Dublin Fringe Festival', 'Galway International Oyster Festival (late Sep)', 'Culture Night (free museum access)'],
    bestFor: 'Oysters, Guinness, live music, and hiking without the rain... hopefully',
    warning: 'Rain is always possible. That\'s the deal. Bring a proper jacket.',
  },
  'Amsterdam': {
    weatherVibe: 'Mild & pleasant',
    temp: '56-64°F',
    water: 'Canal cruise weather',
    crowdLevel: 'Low-Medium',
    crowdNote: 'Summer tourists gone. Locals biking back to normal. Museums accessible.',
    inSeason: ['Dutch cheese at its best', 'Herring season still going', 'Apple harvest'],
    events: ['Amsterdam Dance Event preview events', 'Unseen Photo Fair', 'Open Monumentendag — historic buildings open free'],
    bestFor: 'Biking through uncrowded streets, canal-side drinks in golden light',
    warning: 'Bring a rain jacket. Dutch weather can turn.',
  },
  'Turks & Caicos': {
    weatherVibe: 'Hot & tropical',
    temp: '84-90°F',
    water: 'Bathtub warm (84°F) — Caribbean perfection',
    crowdLevel: 'Very Low',
    crowdNote: 'Hurricane season = lowest prices of the year. Resorts are empty.',
    inSeason: ['Conch season', 'Best snorkeling visibility', 'Whale watching starting'],
    events: ['Turks & Caicos Music & Cultural Festival'],
    bestFor: 'Luxury beach for a fraction of winter prices',
    warning: 'September IS hurricane season. Check weather forecasts. Travel insurance mandatory.',
  },
  'Cancun + Tulum': {
    weatherVibe: 'Hot & humid',
    temp: '82-90°F',
    water: 'Caribbean warm (84°F)',
    crowdLevel: 'Very Low',
    crowdNote: 'Low season. Hotels are 40-50% cheaper. Tulum beach clubs are peaceful.',
    inSeason: ['Sea turtle nesting season', 'Cenote swimming is perfect (cooler underground)', 'Mango season'],
    events: ['Mexican Independence Day (Sep 16) — huge celebrations'],
    bestFor: 'Tulum without the influencer crowds. Cenotes all to yourself.',
    warning: 'Hurricane season + afternoon rain showers most days. Usually clears by evening.',
  },
  'Costa Rica': {
    weatherVibe: 'Green season (wet)',
    temp: '75-82°F',
    water: 'Pacific warm (82°F)',
    crowdLevel: 'Very Low',
    crowdNote: '"Green season" = rain + empty parks + lowest prices. Rainforest is LUSH.',
    inSeason: ['Baby sea turtle releases', 'Whale watching (humpbacks arrive!)', 'Birdwatching peak — quetzals active'],
    events: ['Independence Day (Sep 15) — lantern parades'],
    bestFor: 'Wildlife at its most active. Whales, turtles, birds, sloths — all of it.',
    warning: 'Afternoon rain daily on Pacific side. Caribbean side drier. Plan mornings for outdoor activities.',
  },
  'Cartagena': {
    weatherVibe: 'Hot & vibrant',
    temp: '84-90°F',
    water: 'Caribbean warm (84°F)',
    crowdLevel: 'Low',
    crowdNote: 'Low season = locals\' city. Old Town isn\'t packed. Better prices.',
    inSeason: ['Tropical fruit season', 'Fresh ceviche always peak', 'Colombian coffee harvest'],
    events: ['Hay Festival Cartagena (if scheduled)'],
    bestFor: 'Old town romance, Caribbean beaches, amazing food, low prices',
    warning: 'September is rainy. Short, heavy afternoon showers — they pass quickly.',
  },
  'Aruba': {
    weatherVibe: 'Hot & dry',
    temp: '84-90°F',
    water: 'Caribbean perfect (82°F)',
    crowdLevel: 'Low',
    crowdNote: 'Outside the ABC island belt — barely any hurricanes. Low season prices.',
    inSeason: ['Constant trade winds = kitesurfing paradise', 'Crystal clear water all year'],
    events: ['Caribbean Sea Jazz Festival'],
    bestFor: 'Hurricane-free Caribbean. One of the safest bets in September.',
    warning: null,
  },
  'Bermuda': {
    weatherVibe: 'Warm & beautiful',
    temp: '78-84°F',
    water: 'Still warm (82°F)',
    crowdLevel: 'Low',
    crowdNote: 'Summer crowds gone. Pink beaches practically private.',
    inSeason: ['Lobster season starts September 1st!', 'Wahoo fishing picks up', 'Rum swizzle always in season'],
    events: ['Bermuda Lobster Season Opening'],
    bestFor: 'Pink beaches + fresh lobster season. Can\'t beat that combo.',
    warning: 'Atlantic hurricane season. Watch the forecasts. Only 2 hours from JFK though — easy to rebook.',
  },
  'Azores': {
    weatherVibe: 'Mild & stunning',
    temp: '68-74°F',
    water: 'Atlantic refreshing (72°F)',
    crowdLevel: 'Very Low',
    crowdNote: 'Shoulder season. This place is barely discovered. You\'ll feel like explorers.',
    inSeason: ['Whale watching peak season (blue whales!)', 'Volcanic hot springs at perfect temp', 'Passion fruit and guava harvest'],
    events: ['Sanjoaninas Festival aftermath'],
    bestFor: 'Europe\'s most underrated destination. Volcanoes, whales, hot springs, no crowds.',
    warning: 'Weather changes fast. Four seasons in one day is real here.',
  },
};

export default septemberContext;
